import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex-direction: column;
	height: 100vh;
	background: #fff;
	color: #1a1a1a;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
`;

export const Content = styled.main`
	flex: 1;
	overflow: hidden;
`;
